import React, { useEffect, useState } from 'react';
import ModalSubmitForm from '../modal-submit-form/modal-submit-form';
import { permission, permissionLabels } from '../../../common/constant';
import * as userManagementAction from '../../../redux/store/user-management/user-management.store';
import ShowNotification from '../../react-notifications/react-notifications';
import { NotificationMessageType } from '../../../utils/configuration';
import viVN from '../../../language/vi-VN.json';

const FormAssignPermission = (props) => {
    const {
        triggerSubmit,
        setTriggerSubmit,
        handleSave,
        availablePermissions,
        selectedPermissions,
        handleCheckboxChange
    } = props;

    useEffect(() => {
        if (!triggerSubmit) return;
        handleSave();
        setTriggerSubmit(false);
    }, [triggerSubmit, handleSave, setTriggerSubmit]);

    return (
        <div className="row">
            {availablePermissions.map((item) => (
                <div className="col-md-6 mb-2" key={item.value}>
                    <div className="custom-control custom-checkbox">
                        <input
                            type="checkbox"
                            className="custom-control-input"
                            id={`perm-${item.value}`}
                            checked={selectedPermissions.includes(item.value)}
                            onChange={() => !item.disabled && handleCheckboxChange(item.value)}
                            disabled={item.disabled}
                        />
                        <label className="custom-control-label" htmlFor={`perm-${item.value}`}>
                            {item.label}
                        </label>
                    </div>
                </div>
            ))}
        </div>
    );
};

const ModalAssignPermission = (props) => {
    const { open, onClose, herdsman, onSuccess, showLoading } = props;
    const [selectedPermissions, setSelectedPermissions] = useState([]);
    const [userData, setUserData] = useState(null);

    // Filter out Admin and HoiTruong
    const availablePermissions = Object.keys(permission)
        .filter(key => permission[key] !== permission.Admin && permission[key] !== permission.HoiTruong)
        .map(key => ({
            key: key,
            value: permission[key],
            label: permissionLabels[permission[key]] || key,
            disabled: permission[key] === permission.Owner
        }));

    useEffect(() => {
        if (open && herdsman && herdsman.userId) {
            fetchUserDetails(herdsman.userId);
        } else {
            setSelectedPermissions([]);
            setUserData(null);
        }
    }, [open, herdsman]);

    const fetchUserDetails = async (userId) => {
        showLoading(true);
        try {
            const res = await userManagementAction.GetDetailUserManagement(userId);
            if (res && res.content) {
                setUserData(res.content);
                console.log(res.content);
                if (res.content.roleIds && res.content.roleIds.length > 0) {
                    setSelectedPermissions(res.content.roleIds.map(r => r.value));
                } else {
                    setSelectedPermissions([]);
                }
            }
        } catch (err) {
            console.error(err);
            ShowNotification("Không thể lấy thông tin người dùng", NotificationMessageType.Error);
        } finally {
            showLoading(false);
        }
    }

    const handleCheckboxChange = (value) => {
        if (selectedPermissions.includes(value)) {
            setSelectedPermissions(selectedPermissions.filter(p => p !== value));
        } else {
            setSelectedPermissions([...selectedPermissions, value]);
        }
    }

    const handleSave = async () => {
        if (!userData) return;

        showLoading(true);
        try {
            const formData = new FormData();
            formData.append("Id", userData.id);
            formData.append("FullName", userData.fullName);
            formData.append("UserName", userData.userName);
            formData.append("Email", userData.email || "");
            formData.append("DateOfBirth", userData.dateOfBirth);
            formData.append("Sex", userData.sex);
            formData.append("Address", userData.address);
            formData.append("Description", userData.description);
            formData.append("PhoneNumber", userData.phoneNumber);

            selectedPermissions.forEach((role) => {
                formData.append(`Roles`, role);
            });

            // Keep existing data permissions if any
            if (userData.dataPermissions && userData.dataPermissions.length > 0) {
                userData.dataPermissions.forEach((dp, index) => {
                    formData.append(`dataPermissions[${index}].dataType`, dp.dataType);
                    if (Array.isArray(dp.value)) {
                        if (dp.value.length === 0) {
                            formData.append(`dataPermissions[${index}].value[0]`, 0);
                        } else {
                            dp.value.forEach((val, vIndex) => {
                                formData.append(`dataPermissions[${index}].value[${vIndex}]`, val);
                            });
                        }
                    } else {
                        formData.append(`dataPermissions[${index}].value[0]`, dp.value || 0);
                    }
                });
            } else {
                // Add default empty permissions if none exist to match EditUserManagement logic
                const dataTypes = ["DEPARTMENT", "HERDSMAN", "ZION", "GROUP", "ZIONAREA", "WMTEAM", "BRANCH"];
                dataTypes.forEach((dt, index) => {
                    formData.append(`dataPermissions[${index}].dataType`, dt);
                    formData.append(`dataPermissions[${index}].value[0]`, 0);
                });
            }

            const res = await userManagementAction.UpdateWithMultiRoles(formData);
            if (res) {
                ShowNotification(viVN.Success["UserEditSuccess"] || "Cập nhật thành công", NotificationMessageType.Success);
                onSuccess();
            }
        } catch (err) {
            console.error(err);
            // Fix: more robust error notification
            const errorMsg = (err && err.errorType && viVN.Errors[err.errorType]) || (err && err.errorMessage) || "Có lỗi xảy ra khi cập nhật";
            ShowNotification(errorMsg, NotificationMessageType.Error);
        } finally {
            showLoading(false);
        }
    }

    return (
        <ModalSubmitForm
            open={open}
            onClose={onClose}
            title={`Cấp quyền cho: ${herdsman?.firstName} ${herdsman?.lastName}`}
            // We pass these so they are available in FormAssignPermission via cloneElement in ModalSubmitForm
            handleSave={handleSave}
            availablePermissions={availablePermissions}
            selectedPermissions={selectedPermissions}
            handleCheckboxChange={handleCheckboxChange}
        >
            <FormAssignPermission />
        </ModalSubmitForm>
    );
};

export default ModalAssignPermission;
